<template>
  <bxs-radio-group v-model="radioValue" class="show-radio">
    <bxs-radio
      v-for="(item, index) in options"
      :key="index"
      :name="item.value"
      :data-stat-id="item.stat"
    >
      <slot :item="item" />
    </bxs-radio>
  </bxs-radio-group>
</template>

<script>
export default {
  name: 'ShowRadio',
  props: {
    value: [String, Number],
    options: Array
  },
  computed: {
    radioValue: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    }
  }
}
</script>

<style lang="postcss">
.show-radio {
  display: flex;
  flex-wrap: wrap;
  .bx-radio-warp {
    position: relative;
    padding: 0 0 20px; /*no*/
    overflow: hidden;
    flex-basis: 25%;
  }
  .bx-radio-text {
    margin-left: 0;
  }
  .bx-radio-icon-warp {
    position: absolute;
    bottom: 19px; /*no*/
    left: 7px; /*no*/
  }
}
</style>